import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-issue-transaction-issue-type-form',
  templateUrl: './issue-transaction-issue-type-form.component.html',
  styleUrls: ['./issue-transaction-issue-type-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IssueTransactionIssueTypeFormComponent),
      multi: true
    }
  ]
})
export class IssueTransactionIssueTypeFormComponent implements ControlValueAccessor, OnInit {

  @Input() appearance: 'fill' | 'outline' | 'standard' = 'fill';
  
  valueControl: FormControl = new FormControl();

  private _subscriptions: Subscription[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  public onTouched: () => void = () => { };
  registerOnTouched = (fn: any) => this.onTouched = fn;

  registerOnChange(fn: any): void {
    this._subscriptions.push(this.valueControl.valueChanges.subscribe(fn));
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.valueControl.disable() : this.valueControl.enable();
  }

  writeValue = (val: any) => this.valueControl.patchValue(val);

}
